export default "__VITE_ASSET__D_pDg67U__"